export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=6727c781&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/leads/index.vue?vue&type=template&id=6727c781&
// module id = 1431
// module chunks = 0